import { render, staticRenderFns } from "./kunden-duplicates-merge-modal.vue?vue&type=template&id=739a791e"
import script from "./kunden-duplicates-merge-modal.vue?vue&type=script&lang=js"
export * from "./kunden-duplicates-merge-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports